var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ButtonNext } from 'wix-ui-core/dist/es/src/components/button-next';
import { Text } from '../Text';
import { EVENT_DATA_KEYS } from './dataHooks';
import { st, classes } from './Event.st.css';
/** Event */
var Event = /** @class */ (function (_super) {
    __extends(Event, _super);
    function Event() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._getEventProps = function (isContainer) {
            var _a;
            return isContainer
                ? __assign(__assign({ 'data-hook': _this.props['data-hook'] }, _this.getDataAttributes()), (_a = {}, _a[EVENT_DATA_KEYS.ARIA_Has_Popup] = _this.props['aria-has-popup'], _a[EVENT_DATA_KEYS.ARIA_Expanded] = _this.props['aria-expanded'], _a)) : null;
        };
        _this._getEvent = function (isContainer, className, timeComponent, title) { return (React.createElement("div", __assign({}, _this._getEventProps(isContainer), { className: st(classes.root, { fullday: _this.props.fullday, selected: _this.props.selected }, className) }),
            timeComponent,
            React.createElement(Text, { className: classes.title }, title),
            React.createElement("div", { className: classes.overlay }))); };
        return _this;
    }
    Event.prototype.getDataAttributes = function () {
        var _a;
        var _b = this.props, fullday = _b.fullday, selected = _b.selected, showTime = _b.showTime;
        return _a = {},
            _a[EVENT_DATA_KEYS.IsFullDay] = fullday,
            _a[EVENT_DATA_KEYS.IsSelected] = selected,
            _a[EVENT_DATA_KEYS.IsTimeShown] = showTime,
            _a;
    };
    Event.prototype.render = function () {
        var _a = this.props, time = _a.time, title = _a.title, showTime = _a.showTime, className = _a.className, onClick = _a.onClick, disabled = _a.disabled;
        var timeComponent = showTime && time ? React.createElement(Text, { className: classes.time }, time) : null;
        return onClick ? (React.createElement(ButtonNext, __assign({ onClick: function () { return !disabled && onClick(); }, className: st(classes.buttonContainer) }, this._getEventProps(true)), this._getEvent(false, className, timeComponent, title))) : (this._getEvent(true, className, timeComponent, title));
    };
    Event.displayName = 'Event';
    Event.defaultProps = {
        showTime: true,
        fullday: false,
        selected: false,
        disabled: false,
        onClick: null,
        'aria-has-popup': false,
        'aria-expanded': false,
    };
    return Event;
}(React.Component));
export { Event };
//# sourceMappingURL=Event.js.map